import type { Dispatch, SetStateAction } from 'react';
import React from 'react';
import type { LoggedUser } from '../api';

type GlobalContextType = {
  loggedUser: LoggedUser | null;
  setLoggedUser: Dispatch<SetStateAction<LoggedUser | null>>;
};

export const GlobalContext = React.createContext<GlobalContextType>({
  loggedUser: null,
  setLoggedUser: () => {},
});
